var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "modal_wrap" }, on: { click: _vm.onClose } },
    [
      _c(
        "div",
        {
          class: {
            modal_container: true,
            size_xl: _vm.modalData.size === "xl",
          },
        },
        [
          _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card-header" }, [
              _c("h4", { staticClass: "mb-1" }, [
                _vm._v(_vm._s(_vm.modalData.header)),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "card-body" }, [_vm._t("default")], 2),
            _vm._v(" "),
            _c("div", { staticClass: "card-footer text-right" }, [
              _c(
                "div",
                { staticClass: "btn-group", attrs: { role: "group" } },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-default",
                      on: { click: () => _vm.onModalClose(false) },
                    },
                    [_vm._v("\n            Отмена\n          ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "vue-ladda",
                    {
                      attrs: {
                        type: "submit",
                        disabled: _vm.acceptDisabled,
                        "button-class": "btn btn-success",
                        "data-style": "zoom-in",
                        loading:
                          _vm.modalData.acceptBtnLoading ||
                          _vm.acceptBtnLoading,
                      },
                      on: { click: _vm.onAccept },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.modalData.acceptBtnText || "Сохранить") +
                          "\n          "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }